/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fac_Plan_Feat2Inputs */

const en_fac_plan_feat2 = /** @type {(inputs: Fac_Plan_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branded PDF session reports & participant certificates`)
};

const id_fac_plan_feat2 = /** @type {(inputs: Fac_Plan_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laporan sesi PDF berbranding & sertifikat peserta`)
};

/**
* | output |
* | --- |
* | "Branded PDF session reports & participant certificates" |
*
* @param {Fac_Plan_Feat2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fac_plan_feat2 = /** @type {((inputs?: Fac_Plan_Feat2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fac_Plan_Feat2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fac_plan_feat2(inputs)
	return en_fac_plan_feat2(inputs)
});